module.exports = __webpack_public_path__ + "img/japan-ischemic-heart-disease-female.f6e96fb8.png";